/**
 * Stamps `_b2b` on the cart so discount functions can tell B2B from B2C.
 *
 * Discount functions can't see `customer.b2b?`, and the app's qualifiers offer
 * nothing identity-based. The theme knows the audience, so it writes what the
 * function reads: `_b2b = "true"` for B2B, cleared for B2C.
 *
 * A deferred asset rather than markup in the cart, deliberately: a <script>
 * that arrives via a section morph never executes (see morph.js and the note in
 * scripts.liquid), and the cart drawer is morphed in on the first add. Rendering
 * this beside the cart meant it silently did nothing on exactly the path it
 * exists for — empty cart, add an item, check out from the drawer.
 *
 * Writes nothing when the attribute is already correct, which is the common case.
 */
(function () {
  // `Theme` is declared with `const` in scripts.liquid, which makes it a global
  // lexical binding rather than a property of `window` — so `window.Theme` is
  // undefined. The rest of the theme reads it bare; typeof keeps that safe here.
  if (typeof Theme === 'undefined' || !Theme.b2b) return;
  const flag = Theme.b2b;

  const want = flag.want || '';
  if (want === (flag.current || '')) return;

  // The response carries the updated cart, so the write is confirmed rather than
  // assumed. An earlier version trusted `res.ok`, which hid failures completely.
  const write = (attempt) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _b2b: want } }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('cart update failed: ' + res.status);
        return res.json();
      })
      .then((cart) => {
        const landed = (cart.attributes && cart.attributes._b2b) || '';
        if (landed === want) return;
        if (attempt === 0) return write(1);
        console.warn('[cart-b2b-flag] attribute did not persist; wanted', want, 'got', landed);
      })
      .catch((err) => {
        if (attempt === 0) return write(1);
        console.error('[cart-b2b-flag] sync failed', err);
      });

  // No cart:update dispatch. Nothing the shopper can see has changed, and
  // dispatching one zeroed the header cart badge (cart-icon.js reads itemCount
  // off the event and defaults to 0) and re-ran the gift reconciler against
  // stale config, which could double-add a gift.
  write(0);
})();
